import { isLoopbackHost, sameSiteHost } from "@utils/index";

function firstImage(src) {
  if (Array.isArray(src)) {
    src = src[0];
  }
  if (!src) {
    return "";
  }
  return String(src)
    .split("|")[0]
    .trim();
}

function shouldUseRelativeAsset(host) {
  if (isLoopbackHost(host)) {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  return sameSiteHost(host, window.location.hostname);
}

export function goodsImage(src) {
  let path = firstImage(src);
  if (!path) {
    return "";
  }

  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      if (shouldUseRelativeAsset(url.hostname)) {
        path = url.pathname + (url.search || "");
      } else {
        return path;
      }
    } catch (e) {
      return path;
    }
  }

  if (path.charAt(0) !== "/") {
    path = "/" + path;
  }
  return path;
}

export function rewriteHtmlAssets(html) {
  if (!html) {
    return "";
  }
  let out = String(html).replace(
    /https?:\/\/(?:127\.0\.0\.1|localhost|\[::1\])(?::\d+)?(\/(?:storage|uploads)\/)/gi,
    "$1"
  );
  if (typeof window !== "undefined" && window.location.hostname) {
    const host = String(window.location.hostname)
      .replace(/^www\./i, "")
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    out = out.replace(
      new RegExp(
        `https?://(?:www\\.)?${host}(?::\\d+)?(/(?:storage|uploads)/)`,
        "gi"
      ),
      "$1"
    );
  }
  return out;
}

export function goodsImageList(src) {
  if (Array.isArray(src)) {
    return src.map(item => goodsImage(item)).filter(Boolean);
  }
  const path = firstImage(src);
  return path ? [goodsImage(path)] : [];
}
